import { pathBuilder } from './index';

export const root = '/admin/transfer_events';

export default pathBuilder(root);
